module.exports = __webpack_public_path__ + "bkg-7.1d6dbe9bffd5c31b7830.jpg";


//////////////////
// WEBPACK FOOTER
// F:/Projects/tfs/VS2015/SolventC/SolventCWebsite/Angular4.Website/src/assets/images/bkg-7.jpg
// module id = ../../../../../src/assets/images/bkg-7.jpg
// module chunks = styles